import React, { useRef } from 'react';
import { classes } from '../FileUpload.st.css';
import File from './File';
import FileUploadPopover from './FileUploadPopover';
import { DATA_HOOKS } from '../dataHooks';
import { useFocusWhen } from './use-focus-when';
import { usePrevious } from './use-previous';
export function FileList(_ref) {
  let {
    fileInputRef,
    textBelowButtonRef,
    files,
    onDeleteClick,
    hasError,
    explanationText
  } = _ref;
  const indicateError = Boolean(files == null ? void 0 : files.find(file => file.state === 'error')) && hasError;
  const isOneFile = files.length === 1;
  const singleFileDeleteButtonRef = useRef(null);
  const previousFileLength = usePrevious(files.length) ?? 0;
  useFocusWhen(() => {
    return files.length === 1 && previousFileLength > 1;
  }, singleFileDeleteButtonRef);
  const handleDeleteClick = i => {
    const fileToDelete = files == null ? void 0 : files[i].file;
    if (fileToDelete && fileInputRef.current && `${fileInputRef.current.value}`.includes(fileToDelete.name)) {
      fileInputRef.current.value = '';
    }
    onDeleteClick == null || onDeleteClick(i);
  };
  if (isOneFile) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.oneFile,
      ref: textBelowButtonRef
    }, /*#__PURE__*/React.createElement(File, {
      file: files[0],
      onDeleteClick: () => handleDeleteClick(0),
      dataHook: DATA_HOOKS.singleFile,
      deleteButtonRef: singleFileDeleteButtonRef
    }));
  }
  return /*#__PURE__*/React.createElement(FileUploadPopover, {
    files: files,
    onDeleteClick: handleDeleteClick,
    explanationText: explanationText,
    hasError: indicateError,
    setTextBelowButtonRef: element => textBelowButtonRef.current = element
  });
}
//# sourceMappingURL=FileList.js.map